/* eslint-disable react/prop-types */
import React, { useContext } from 'react';
import sortBy from 'lodash/sortBy';
import {
  Table,
  TableColumn,
  TableHeaderColumn,
} from '@alefeducation/ui-elements-library-core';
import { useTranslation } from 'react-i18next';
import AssignmentContext from '../../../common/AssignmentContext/AssignmentContext';
import { filterBySelectedTeam } from '../../helpers';
import { useStudentListContext } from '../StudentListContext';
import { useCommonSectionItemElements } from '../useCommonSectionItemElements';
import { NewStudentListSection } from './StudentListSection/NewStudentListSection';
import {
  evaluationDateColumn,
  fileColumn,
  gradeColumn,
  resubmissionColumn,
  studentColumn,
  submissionDateColumn,
} from './commonStudentSectionColumns';
import { actionColumnWidth } from './constants';

export const NewLeftTheClassSection = () => {
  const {
    groupedSubmissions,
    onViewStudent,
    dueOn,
    attachmentRequired,
  } = useStudentListContext();
  const { leftTheClass } = groupedSubmissions;
  const { t } = useTranslation();

  const {
    filters: { selectedTeamMembersIds, selectedTeamFilter },
  } = useContext(AssignmentContext);

  const studentsWhoLeftTheClassSubmissions =
    leftTheClass &&
    filterBySelectedTeam(
      selectedTeamFilter,
      selectedTeamMembersIds,
      leftTheClass,
    );

  const sectionItems =
    studentsWhoLeftTheClassSubmissions &&
    sortBy(
      studentsWhoLeftTheClassSubmissions,
      ({ student }) => student.name,
    ).map(({ student, submission, resubmission }) => ({
      ...student,
      submission,
      resubmission,
    }));

  const sectionItemsTable =
    studentsWhoLeftTheClassSubmissions &&
    studentsWhoLeftTheClassSubmissions.length > 0 ? (
      <Table
        rows={sectionItems}
        columns={[
          studentColumn(t),
          { ...submissionDateColumn(dueOn, t) },
          { ...evaluationDateColumn(t) },
          { ...fileColumn(attachmentRequired, t) },
          { ...resubmissionColumn(t) },
          { ...gradeColumn(t, '364px') },
          {
            key: 'id',
            name: t('Actions'),
            renderColumn: ({ row }) => {
              const { viewIcon, feedbackField } = useCommonSectionItemElements(
                row,
                row.submission,
              );
              return (
                <TableColumn
                  row={row}
                  isFirstColumn={false}
                  className="actions-cell"
                >
                  <div className="actions-container">
                    {feedbackField.props.isResponseGiven && feedbackField}
                    {viewIcon(row, onViewStudent)}
                  </div>
                </TableColumn>
              );
            },
            renderHeaderColumn: rows => (
              <TableHeaderColumn
                isFirstColumn={false}
                rows={rows}
                width={actionColumnWidth}
              >
                <div className="col-heading">{t('Actions')}</div>
              </TableHeaderColumn>
            ),
            alignText: 'right',
            width: actionColumnWidth,
            height: '44px',
          },
        ]}
        isSticky={true}
        translationKeys={t}
      />
    ) : null;

  return (
    <NewStudentListSection
      labelColor={'#FFFFFF'}
      data-testid="left-the-class-section"
      submissions={studentsWhoLeftTheClassSubmissions}
      sectionName={t('Left the Class')}
      sectionItems={sectionItemsTable}
    />
  );
};
